import React, { Component } from "react";
import "./Sketch.css";
import ImageLoader from "./common/ImageLoader";
import TextPrompt from "./TextPrompt";
import { BsPenFill, BsFillEraserFill, BsTrash } from "react-icons/bs";
import { ImRedo, ImUndo } from "react-icons/im";
import { ReactSketchCanvas } from "react-sketch-canvas";
import { SketchTutorial } from "./Tutorials";
import { FaQuestionCircle } from "react-icons/fa";


class Sketch extends Component {
    constructor(props) {
        super(props);
        this.canvas = React.createRef();
    }

    state = {
        color: "#000000",
        penSize: 10,
        isEraser: false,
        showHelp: false,
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
    }

    handleColorChange = (color) => {
        this.setState({ color: color.hex });
    }

    handlePenSizeChange = (size) => {
        this.setState({ penSize: size });
    }

    handlePenMode = (isEraser) => {
        this.canvas.current.eraseMode(isEraser)
        this.setState({ isEraser })
    }

    handleRedo = () => {
        this.canvas.current.redo()
    }

    handleUndo = () => {
        this.canvas.current.undo()
    }

    handleSubmit = (prompt) => {
        // this.canvas.current
        //     .exportPaths()
        //     .then(async (data) => {
        //         console.log(data)
        //         const jsonString = JSON.stringify(data);
        //         // Create new Blob object from JSON string
        //         const blob = new Blob([jsonString], { type: 'application/json' });
        //         console.log(blob.size)
        //     })
        //     .catch(e => { console.log(e) })
        this.canvas.current
            .exportImage("png")
            .then(async (data) => {
                await this.props.handleSketchSave(data);
                await this.props.submit(prompt);
            })
            .catch(e => {
                console.log(e);
            });

    }

    componentDidMount() {
        window.addEventListener('resize', this.handleWindowResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowResize);
    }

    handleWindowResize = () => {
        this.setState({
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight
        });
    }

    render() {
        // const wn = (Math.floor(window.innerWidth / 64) * 64) - 64;
        const { windowWidth, windowHeight } = this.state;
        let w;
        if (windowWidth > 800) {
            w = Math.round(windowWidth * .7);
            w = Math.min(w, .6 * windowHeight);
            w = (w - 15).toString() + "px"
        } else {
            w = windowWidth > 640 ? "640px" : (windowWidth - 15).toString() + "px";
        }
        return (
            <div style={{ width: "100%", height: "100%" }}>
                <div style={{ color: "white", textAlign: "center", fontSize: "10pt", margin: "5px" }}>
                    {"Smart Sketch "}
                    <FaQuestionCircle size={15} onClick={() => this.setState({ showHelp: true })} style={{ verticalAlign: "middle", cursor: "pointer" }} />
                </div>
                {this.state.showHelp &&
                    <SketchTutorial close={() => { this.setState({ showHelp: false }) }} />
                }
                <div className="sketch-container">


                    {this.props.loading
                        ? <ImageLoader />
                        : null
                    }
                    <ReactSketchCanvas
                        ref={this.canvas}
                        strokeWidth={this.state.penSize}
                        strokeColor={this.state.color}
                        eraserWidth={this.state.penSize}
                        width={w}
                        height={w}
                        style={{
                            margin: 0,
                        }}
                    />

                    <div className="tool-container-sketch" style={{ width: w }}>
                        <div className="tool-color-sketch">
                            <input
                                className="input-pen-color"
                                type="color"
                                value={this.state.color}
                                onInput={(e) => { this.setState({ color: e.currentTarget.value }) }}
                            // disabled={this.state.isEraser}
                            />



                            <input
                                className="input-pen-size"
                                type="range"
                                min={2}
                                max={100}
                                value={this.state.penSize}
                                onInput={(e) => this.setState({ penSize: parseInt(e.currentTarget.value) })}
                                style={{ backgroundColor: this.state.color }}
                            />
                        </div>


                        <div className="tool-button-sketch-cont" >
                            <button className="tool-button-sketch"
                                onClick={this.handlePenMode.bind(this, false)}
                                disabled={!this.state.isEraser}
                            >
                                <BsPenFill style={{ verticalAlign: "middle" }} size={18} />
                            </button>
                            <button className="tool-button-sketch"
                                onClick={this.handlePenMode.bind(this, true)}
                                disabled={this.state.isEraser}
                            >
                                <BsFillEraserFill style={{ verticalAlign: "middle" }} size={18} />
                            </button>
                            <button className="tool-button-sketch"
                                onClick={this.handleUndo}
                            >
                                <ImUndo style={{ verticalAlign: "middle" }} size={18} />
                            </button>
                            <button className="tool-button-sketch"
                                onClick={this.handleRedo}
                            >
                                <ImRedo style={{ verticalAlign: "middle" }} size={18} />
                            </button>
                            <button className="tool-button-sketch"
                                onClick={() => this.canvas.current.resetCanvas()}
                            >
                                <BsTrash style={{ verticalAlign: "middle" }} size={18} />
                            </button>
                        </div>


                    </div>
                </div>


                <TextPrompt
                    submit={this.handleSubmit}
                    prompt={this.props.prompt}
                />
            </div >
        );
    }
};

export default Sketch;